import {
  DATA_REQUEST_ASYNC,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_DETECTED_BY_FILTER,
} from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

const generalFilterChange = (value) => ({
  type: GENERAL_FILTER_CHANGE,
  payload: { value },
})

const setDetectedByFilter = (values) => ({
  type: SET_DETECTED_BY_FILTER,
  payload: { values },
})

export default {
  // to props
  fetchData,
  fetchDataCancel,
  searchChange,
  searchReset,
  paginateChange,
  generalFilterChange,
  setDetectedByFilter,
}
